// extracted by mini-css-extract-plugin
export default {"label":"label__1AVli","labelActive":"labelActive__2Qy4M","labelInactive":"labelInactive__w5Cmg"};
    if(module.hot) {
      // 1778491689353
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  